import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
});

// Request interceptor
apiClient.interceptors.request.use(config => {
  if (!document.cookie) {
    document.cookie = "code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/register"
    ) {
      window.location.href = "/login";
    }

    return config;
  }
  const token = document.cookie
    .split("; ")
    .find(row => row.startsWith("code="))
    .split("=")[1];
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      return Promise.reject({
        message: "Network error. Please check your internet connection."
      });
    }

    const status = error.response.status;

    if (status === 401) {
      document.cookie = "code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    const message =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : "Something went wrong";

    return Promise.reject({
      status: status,
      message: message,
      data: error.response.data
    });
  }
);

export default apiClient;
